// @flow

import ApiObject from './ApiObject';
import ApiConstants from '../constants/ApiConstants';

import RestaurantLegalRepresentative from './RestaurantLegalRepresentative';
import RestaurantLegalBank from './RestaurantLegalBank';
import Address from './Address';

export default class RestaurantLegal extends ApiObject {

  id: string = '';

  name: string = '';

  managerName: string = '';

  managerPhone: string = '';

  address: Address = new Address();

  siren: string = '';

  vatNumber: string = '';

  statute: string = '';

  email: string = '';

  registrationProof: string = '';

  shareholderDeclaration: string = '';

  representative: RestaurantLegalRepresentative = new RestaurantLegalRepresentative();

  bank: RestaurantLegalBank = new RestaurantLegalBank();

  postJsonAssignation(data: Object) {
    this.bank = new RestaurantLegalBank();
    this.bank.fromJson(data.bank);

    this.address = new Address();
    this.address.fromJson(data.address);

    this.representative = new RestaurantLegalRepresentative();
    this.representative.fromJson(data.representative);
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/RestaurantLegal.js